import { render, staticRenderFns } from "./chepai.vue?vue&type=template&id=2ebdd2f7"
import script from "./chepai.vue?vue&type=script&lang=js"
export * from "./chepai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports